import React, { useEffect } from "react";
import { Link } from "react-router-dom";

function Search(props) {
  const back = <img src="../images/round-line-left-arrow.svg" alt="<" />;
  const { trigger, searchValue, setSearchValue, handleSearchValue } = props;

  useEffect(() => {
    trigger((prev) => !prev);
    return () => {
      trigger((prev) => !prev);
      setSearchValue("");
    }
  }, [setSearchValue, trigger])

  return (
    <div className="search">
      <Link to="../">
        <div
          className="back"
        >
          {back}
        </div>
      </Link>
      <h2>Filtruj</h2>
      <form>
        <input
          type="text"
          value={searchValue}
          onChange={handleSearchValue}
        ></input>
      </form>
    </div>
  );
}

export default Search;
